module.exports = __webpack_public_path__ + "static/media/avatar.4867e5b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = 226
// module chunks = 0